import { Box, Paper, Typography } from '@mui/material';
import type { GridMetadata } from '../../../menu/types';

type GridDebugPanelProps = {
  columns?: unknown;
  metadata?: GridMetadata;
  visible?: boolean;
};

export const GridDebugPanel = ({ columns, metadata, visible = true }: GridDebugPanelProps) => {
  if (!visible) return null;

  return (
    <>
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Debug: Columns Configuration
        </Typography>
        <Box
          component="pre"
          sx={{
            backgroundColor: '#1e1e1e',
            color: '#d4d4d4',
            p: 2,
            borderRadius: 1,
            overflow: 'auto',
            maxHeight: 400,
            fontSize: '0.75rem',
          }}
        >
          {JSON.stringify(columns, null, 2)}
        </Box>
      </Paper>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Debug: Full Metadata
        </Typography>
        <Box
          component="pre"
          sx={{
            backgroundColor: '#1e1e1e',
            color: '#d4d4d4',
            p: 2,
            borderRadius: 1,
            overflow: 'auto',
            maxHeight: 400,
            fontSize: '0.75rem',
          }}
        >
          {JSON.stringify(metadata, null, 2)}
        </Box>
      </Paper>
    </>
  );
};
